<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Notifications</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('notification.create')">
        <span>Add</span>
        <span class="hidden md:inline">Notification</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Enabled</th>
          <th class="px-6 pt-6 pb-4">Wait Time</th>
          <th class="px-6 pt-6 pb-4">Message</th>
        </tr>

        <tr v-for="notification in notifications.data" :key="notification.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('notification.edit', notification.id)" tabindex="-1">
              {{ notification.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('notification.edit', notification.id)" tabindex="-1">
              {{ notification.is_enabled == true ? "🟢" : "🔴" }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('notification.edit', notification.id)" tabindex="-1">
              {{ notification.wait_time }} min
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center" :href="route('notification.edit', notification.id)" tabindex="-1">
                <index-preview :preview_message='truncate(notification.message)' />
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('notification.edit', notification.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="notifications.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No notifications found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="notifications.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import IndexPreview from '../../Shared/IndexPreview.vue'

export default {
  metaInfo: { title: 'Notifications' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    IndexPreview,
  },
  layout: Layout,
  props: {
    filters: Object,
    notifications: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('notification'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    nodes(message) {
        console.log(message)
        return message.split(' ')
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    truncate(data) {
        var truncated;
        truncated = data.split(" ").slice(0, 20).join(" ") + " (...)";
      if(truncated > 80){
        truncated =  truncated.split(" ").slice(0, 15).join(" ") + "(...)";
      }
      return data;
    }
  },
}
</script>
